'use strict';

const grade = window.grade;
const clicksend_user = grade.clicksend_user;
const clicksend_key = grade.clicksend_key;
const clicksend_sms_endpoint = 'https://rest.clicksend.com/v3/sms/send';
const clicksend_email_endpoint = 'https://rest.clicksend.com/v3/email/send';
const encodedAPI = btoa(clicksend_user + ':' + clicksend_key);
const clicksend_from_email = 1386; // 1281 = grade test acc

import VueRecaptcha from 'vue-recaptcha'

import axios from 'axios';
import regeneratorRuntime from "regenerator-runtime";

module.exports = {
	name: 'App',

	el: '.notify-tool',

	components: {VueRecaptcha},

	data: function () {
		return {
			complete: false,
			issues: [],
			maxPartners: 3,
			stiList: window.sti_list,
			type: [],
			partners: [{
				name: null,
				contact: null
			}],
			recaptchaKey: window.grade.siteKey,
			isSubmitting: false,
			isReady: false,
			blockUserByIP: null,
			geoLocateFail: null
		};
	},

	mounted() {
		this.getGeoLocation()
	},

	methods: {
		async getGeoLocation() {
			const self = this

			await axios.get('https://ipinfo.io/json?token=b4cbc6989352bc')
				.then(response => {
					self.geoLocateFail = false

					if (response.status == 200) {
						if (response.data.country === 'AU' || response.data.country === 'au') {
							self.blockUserByIP = false
						} else {
							self.blockUserByIP = true
						}
					} else {
						if (response.status == 429) {
							// if rate limit of API exceeded, just allow access for now..
							self.blockUserByIP = false
						}
					}
				})
				.catch(error => {
					console.error('error getting geolocation', error)
					self.geoLocateFail = true
				})
				.finally(function () {
					self.isReady = true
				})
		},

		addPartner: function () {
			this.partners.push({
				name: null,
				contact: null
			});
		},

		removePartner(index) {
			this.partners.splice(index, 1);
		},

		submit: function () {
			this.$refs.recaptcha.execute();
			this.isSubmitting = true;
		},

		onVerify: function (response) {
			if (response) {
				this.sendMessage();
				this.$refs.recaptcha.reset();
			}
		},

		onExpired: function () {
			this.$refs.recaptcha.reset();
		},

		sendMessage: function () {
			var self = this;

			if (self.isSMS) {
				// send as SMS
				var data = {'messages': []};
				this.messages.forEach(function (message) {
					data.messages.push(message);
				});

				var request = new XMLHttpRequest();
				request.open('POST', clicksend_sms_endpoint);
				request.setRequestHeader('Content-Type', 'application/json');
				request.setRequestHeader('Authorization', 'Basic ' + encodedAPI);

				request.onreadystatechange = function () {
					if (this.readyState === 4) {
						// console.log('Status:', this.status);
						// console.log('Headers:', this.getAllResponseHeaders());
						// console.log('Body:', this.responseText);
						if (this.status === 200) {
							self.success();
						} else {
							self.fail();
						}
					}
				};
				// fire when ready
				request.send(JSON.stringify(data));
			} else {
				// send as email
				this.messages.forEach(function (message) {
					var request = new XMLHttpRequest();
					request.open('POST', clicksend_email_endpoint);
					request.setRequestHeader('Content-Type', 'application/json');
					request.setRequestHeader('Authorization', 'Basic ' + encodedAPI);

					// we need to build an email template around the message
					// until ClickSend sort their shiz out to build on backend
					// do this here to keep html out of EHIV FE preview
					var bodyContent = message.body;
					var wrapStart = '<div style="padding: 20px 45px; border: 5px solid #000; max-width: 640px;">';
					var wrapEnd = '</div>';
					// overwrite existing body
					message.body = wrapStart + bodyContent + wrapEnd;


					request.onreadystatechange = function () {
						if (this.readyState === 4) {
							// console.log('Status:', this.status);
							// console.log('Headers:', this.getAllResponseHeaders());
							// console.log('Body:', this.responseText);
							if (this.status === 200) {
								self.success();
							} else {
								self.fail();
							}
						}
					};
					// fire when ready
					request.send(JSON.stringify(message));
				});

			}
		},

		success: function () {
			this.complete = !this.complete;
			// scroll to top of page
			$('html,body').animate({scrollTop: 0}, 600);
			this.isSubmitting = false;
			this.$refs.recaptcha.reset();
		},

		fail: function () {
			window.alert('There was a problem sending your message(s).\n\n'
				+ 'Please check you\'ve completed all the steps.');

			this.isSubmitting = false;
			this.$refs.recaptcha.reset();
		},

		reset: function () {
			// reset initial states to start over
			this.complete = false;
			this.issues = [];
			this.type = [];
			this.partners = [{
				name: null,
				contact: null
			}];
			this.isSubmitting = false;
		}

	},

	computed: {
		isSMS: function () {
			if (this.type === 'send_sms') {
				return true;
			}
			return false;
		},

		hasPartner: function () {
			if (
				this.partners[0] &&
				this.partners[0].name !== null &&
				this.partners[0].name !== '' &&
				this.partners[0].contact !== null &&
				this.partners[0].contact !== ''
			) {
				return true;
			}
			return false;
		},

		hasMessage: function () {
			return this.hasPartner && this.issues.length;
		},

		messages: function () {
			var self = this;
			var res = [];
			if (!this.problems) return res;

			var problems = this.problems;

			this.partners.forEach(function (partner) {
				var message;
				var messageBody;

				if (!!partner.name && !!partner.contact) {
					if (self.isSMS) {
						// set up SMS
						messageBody = window.notify_message;
						messageBody = messageBody.replace('{{ previewName }}', partner.name);
						messageBody = messageBody.replace('{{ stis }}', problems);
						message = {
							'to': partner.contact,
							'from': 'EndingHIV',
							'body': messageBody
						};
					} else {
						// set up email
						messageBody = window.notify_email_message;
						messageBody = messageBody.replace('{{ previewName }}', partner.name);
						messageBody = messageBody.replace('{{ stis }}', problems);
						message = {
							'to': [
								{
									'email': partner.contact,
									'name': partner.name
								}
							],
							'from': {
								'email_address_id': clicksend_from_email,
								'name': 'Ending HIV'
							},
							'subject': 'Health check',
							'body': messageBody
						};
					}

					res.push(message);
				}
			});

			return res;
		},

		preview: function () {
			return this.messages[0].body || 'Please complete each step';
		},

		problems: function () {
			if (!this.issues.length) return null;
			return this.issues.length == 1
				? this.issues[0]
				: [this.issues.slice(0, -1).join(', '), this.issues.slice(-1)].join(' and ');
		}
	}
};
